package com.example.mystybag.sharedmodels.project.responseModels.merchant

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class GetCompanyBookDataResponseModel(
    val company: CompanyDetails,
    val history: List<HistoryEntry>? = null
)

@Serializable
data class CompanyDetails(
    val id: String,
    val uic: String,
    val companyName: CompanyName,
    val companyNameTransliteration: CompanyName? = null,
    val legalForm: String,
    val status: String,
    val seat: AddressDetails,
    val correspondenceSeat: AddressDetails? = null,
    val contacts: ContactDetails,
    val subjectOfActivity: String? = null,
    val nkids: List<NkidEntry>? = null,
    val managers: List<ManagerEntry>? = null,
    val partners: List<PartnerEntry>? = null,
    val registerInfo: RegisterInfo? = null,
    val depositedFunds: DepositedFunds? = null,
    val lastUpdated: String? = null,
    val history: List<String>? = null,
    val latestRevenue: String? = null
)

@Serializable
data class CompanyName(
    val name: String
)

@Serializable
data class AddressDetails(
    val countryID: String,
    val countryCode: String,
    val country: String,
    val isForeign: String,
    val districtID: String,
    val districtEkatte: String,
    val district: String,
    val municipalityID: String,
    val municipalityEkatte: String,
    val municipality: String,
    val settlementID: String,
    val settlementEKATTE: String,
    val settlement: String,
    val areaID: String? = null,
    val area: String? = null,
    val areaEkatte: String? = null,
    val postCode: String? = null,
    val foreignPlace: String? = null,
    val housingEstate: String? = null,
    val street: String,
    val streetNumber: String,
    val block: String? = null,
    val entrance: String? = null,
    val floor: String? = null,
    val apartment: String? = null
)

@Serializable
data class ContactDetails(
    val phone: String,
    val fax: String,
    val email: String,
    val url: String
)

@Serializable
data class NkidEntry(
    val code: String,
    val description: String,
    val id: String
)

@Serializable
data class ManagerEntry(
    val indent: String,
    val name: String,
    val countryName: String,
    val indentType: String
)

@Serializable
data class PartnerEntry(
    val person: PersonDetails,
    val liabilityType: String,
    val contribution: String
)

@Serializable
data class PersonDetails(
    val indent: String,
    val name: String,
    val countryName: String,
    val indentType: String
)

@Serializable
data class RegisterInfo(
    val name: String,
    val vat: String,
    val address: String,
    val region: String,
    val municipality: String,
    val settlement: String,
    val registrationBasis: String,
    val registrationDate: String
)

@Serializable
data class DepositedFunds(
    val euro: Boolean,
    val value: String
)

@Serializable
data class HistoryEntry(
    val deedUIC: String,
    val timestamp: String,
    val changeType: String,
    val field: String,
    val oldValue: JsonElement? = null,
    val newValue: JsonElement? = null
)
